@import "src/style/lib";

.shop-front-page {
  .products-header {
    padding: 0.5rem calc($grid-gutter-width / 2) 1rem;
  }

  h1 {
    padding: 30px 0 15px 0;
  }

  .category-links {
    h3 {
      display: none;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-top: calc($grid-gutter-width / 2);
      margin-bottom: calc($grid-gutter-width / 2);
      margin-left: calc(-1 * $grid-gutter-width / 2);
      margin-right: calc(-1 * $grid-gutter-width / 2);
      font-size: 1.2em;
      font-weight: $headings-font-weight;
      letter-spacing: -0.01em;
      li {
        margin: 0 15px;
      }
    }
  }
}
